import { createFileRoute, Outlet, useRouterState } from "@tanstack/react-router";
import type { JSX } from "react";
import AdminUserPage from "@/components/admin/admin-user-page";
import { pathToAdminUserTab } from "@/lib/admin/admin-paths";

const AdminUserLayout = (): JSX.Element => {
	const { userId } = Route.useParams();
	const tab = useRouterState({
		select: (state) => {
			const pathname = state.resolvedLocation?.pathname ?? state.location.pathname;
			return pathToAdminUserTab(state.location.pathname, userId) ?? pathToAdminUserTab(pathname, userId);
		},
	});
	return (
		<AdminUserPage tab={tab} userId={userId}>
			<Outlet />
		</AdminUserPage>
	);
};

export const Route = createFileRoute("/_app/admin/users/$userId")({
	component: AdminUserLayout,
});
